import Can from '../Can';
// IMPORT PROJECT REFERENCES
import { DocumentDetails } from '../Document/DocumentDetails';
import PropTypes from 'prop-types';
// IMPORT PACKAGE REFERENCES
import React from 'react';

// COMPONENT
export const DocumentPage = ({ match, location }) => (
    <div className="p-3">
        <Can I="read" a="Document">
            <DocumentDetails
                documentId={match.params.id}
                backLink={location.state ? location.state.backLink : null}
            />
        </Can>
    </div>
);

DocumentPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }),
    location: PropTypes.shape({
        state: PropTypes.shape({
            backLink: PropTypes.string,
        }),
    }),
};
